import {render} from 'preact';
import HeaderSearchSuggestions from '@components/search/HeaderSearchSuggestions';
import LegacySearchSuggestions from '@components/search/LegacySearchSuggestions';
import {getSearchFeatures} from '@components/search/searchFeatures';

const MOUNT_NODE_ID = 'search-suggestions-mount--header';
const navigateToUrl = url => window.location.assign( url );

const SearchSuggestions = {
    init ( {navigate = navigateToUrl} = {} ) {
        const searchBoxWrapper = document.getElementById( 'search-bar-wrapper--header' );
        const searchInput = searchBoxWrapper && searchBoxWrapper.querySelector( 'input[type="text"]' );
        const {fullSite, suggestions} = getSearchFeatures();

        if ( !fullSite && !suggestions ) {
            if ( searchBoxWrapper ) {
                searchBoxWrapper.hidden = true;
                searchBoxWrapper.style.display = 'none';
            }
            document.querySelectorAll( '[data-action="search-bar-toggle--mobile"]' ).forEach( node => {
                node.hidden = true;
                node.style.display = 'none';
            } );
            return;
        }

        if ( searchBoxWrapper && searchInput && searchBoxWrapper.dataset.websiteSearchInitialized !== 'true' ) {
            const suggestionAnchor = searchInput.parentElement || searchBoxWrapper;
            const mountNode = document.createElement( 'div' );

            mountNode.id = MOUNT_NODE_ID;
            if ( fullSite ) {
                suggestionAnchor.appendChild( mountNode );
            }
            else {
                searchBoxWrapper.innerHTML = '';
                mountNode.className = 'w-full';
                searchBoxWrapper.appendChild( mountNode );
            }

            render(
                fullSite ? <HeaderSearchSuggestions
                    navigate={navigate}
                    searchBoxWrapper={searchBoxWrapper}
                    searchInput={searchInput}
                    suggestionsEnabled={suggestions}
                /> : <LegacySearchSuggestions
                    initialQuery={searchInput.value}
                    navigate={navigate}
                />,
                mountNode
            );

            searchBoxWrapper.dataset.websiteSearchInitialized = 'true';
        }
        else if ( !searchBoxWrapper || !searchInput ) {
            console.warn( 'Could not mount <Search/> component; Root node #SearchBox not found' );
        }
    }
};

export default SearchSuggestions;
